import EditRegistrationTemplateDrawer from './EditRegistrationTemplateDrawer';
import RegistrationTemplates from './RegistrationTemplates';

export default RegistrationTemplates;

export { EditRegistrationTemplateDrawer };
